import React, {useEffect, useMemo, useState} from 'react';
import {useAppDispatch, useAppSelector} from "../../../../../hooks/redux";
import {getTexts} from "../../../../../store/selectors/textsSelectors";
import {EnumTextTypes} from "../../../../../enums/EnumTextTypes";
import styles from './ContentDescription.module.css'
import AdminEditableTextWrapper from "../../../../Utils/Admins/AdminEditableTextWrapper/AdminEditableTextWrapper";
import {getLanguage} from "../../../../../store/selectors/appSelector";
import TextEditor from "../../../../Utils/TextEditor/TextEditor";
import {updatePageTextThunk} from "../../../../../store/actions/TextsActions";
import {getTextByLanguage} from "../../../../../enums/utils/getTextByLanguage";


interface IProps {
    description?: string,
    pageName?: string,
    editable?: boolean
}

const ContentDescription = ({pageName, description, editable}: IProps) => {

    const texts = useAppSelector(getTexts)
    const language = useAppSelector(getLanguage)

    const dispatch = useAppDispatch()

    const descriptionFromBD = texts.filter((text) => text.page === pageName).find(text => text.type === EnumTextTypes.description)

    const [isEditMode, setIsEditMode] = useState<boolean>(false)
    const [value, setValue] = useState<string>('')

    useEffect(() => {
        descriptionFromBD && setValue(getTextByLanguage(descriptionFromBD.text, language))
    }, [descriptionFromBD, language])

    const configTextEditor = useMemo(() => {
        return {
            language,
            hidePoweredByJodit: true,
            className: styles.textStyle,
        }
    }, [language])

    const updateTextHandler = () => {
        descriptionFromBD && dispatch(updatePageTextThunk({
            id: descriptionFromBD.id,
            text: value,
            language
        }))
        setIsEditMode(false)
    }

    if (editable) {
        return (
            <>

                {!isEditMode &&
                    <AdminEditableTextWrapper setEditMode={setIsEditMode}>
                        <div
                            className={styles.textStyle}
                            dangerouslySetInnerHTML={{__html: value && value.length ? value : '<p>Скоро тут будет текст</p>'}}></div>
                    </AdminEditableTextWrapper>}

                {isEditMode && <TextEditor updateText={updateTextHandler} setValue={setValue} value={value} setIsEditMode={setIsEditMode} config={configTextEditor}/>}
            </>
        )
    }


    return (
        <div className={styles.textStyle}>
            {!editable && <p>{description}</p>}
        </div>
    )
}

export default ContentDescription;